module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("1")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("F")]), _vm._v("or ten years after earning her MBA, Graciella Miramar lived what seemed to be a perfectly normal and circumspect life in Panama City, Panama, sharing a two-bedroom condo unit with her invalid mother, Christina. El Sueño, their aging condominium complex, was located on Calle 61 Este, well within walking distance of Graciella’s account manager job with a financial firm located in a low-rise office building on Vía Israel a few blocks away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anyone observing Graciella out on the street would have found her totally unremarkable. She wore no wedding ring, but the clothing she favored—modest dresses topped by cardigans and worn with sensible shoes—gave her a somewhat matronly appearance that belied the fact that she was in her early thirties. Her long dark hair was lush enough and could have been cut and styled in an attractive fashion, but she insisted on wearing it pulled back into a severe bun that would have done credit to a librarian. It was a look she had originally adopted in order to stay below the touchy/feely radar of her boss, Arturo Salazar, who was well known for making inappropriate sexual advances. In the long run, though, she had maintained the plain-Jane look because it helped keep other people at bay as well.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Had anyone interviewed Graciella’s neighbors, including the ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("other residents on El Sueño’s fifth floor, he or she would have heard them sing her praises. She was quiet and soft-spoken. They regarded her as a kind young woman and a devoted daughter who was spending what should have been the best years of her life caring for a troubled, housebound mother. For years the older woman’s only regular excursions outside the building had come about on those Sunday mornings when Graciella had bundled her mother into a cab to take them both to mass at Our Lady of Guadalupe on Calle 69 Este.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Yes, Graciella Miramar was an altogether ordinary young woman who, for all intents and purposes, appeared to be living an altogether ordinary life. There was nothing in her actions or demeanor that suggested what she really was—a stone-cold killer in the making, waiting patiently for the proper time and place when she would strike out and claim her first victim. And even then, after it happened, the people around her and the ones who knew her best never suspected a thing.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c53c630","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 72
// module chunks = 0